module.exports = __webpack_public_path__ + "img/213.f6003e74.jpg";